module.exports = __webpack_public_path__ + "img/86ne.d72cd399.svg";